import React from 'react';
import LevelGraph from '../LevelGraph/LevelGraph';
import './StateSummary.scss';

export const SUMMARY_STAGES = [
  {
    icon: 'foundation',
    label: 'Readiness',
    levelKey: 'readiness_level',
  },
  {
    icon: 'experiment',
    label: 'Piloting',
    levelKey: 'piloting_level',
  },
  {
    icon: 'build_circle',
    label: 'Implementation',
    levelKey: 'implementation_level',
  },
  {
    icon: 'insights',
    label: 'Impact',
    levelKey: 'impact_level',
  },
];

function capitalizeFirstLetter(str) {
  if (typeof str !== 'string' || str.length === 0) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const StateSummary = ({ stateData, showName = true, className = '' }) => {
  return (
    <div className={`state-summary${showName ? '' : ' state-summary--name-hidden'}${className ? ` ${className}` : ''}`}>
      {showName && <div className="state-summary__name text-center">{ stateData.name }</div>}
      <div className="state-summary__dimensions">
        {SUMMARY_STAGES.map((stage) => (
          <StateSummaryDimension key={stage.levelKey} stateData={stateData} stage={stage} />
        ))}
      </div>
    </div>
  );
};

export const StateSummaryDimension = ({ stateData, stage, className = '' }) => {
  const level = stateData[stage.levelKey];

  return (
    <div className={`state-summary__dimension${className ? ` ${className}` : ''}`}>
      <div className="state-summary__dimension-copy">
        <strong className="stage-label state-summary__stage">
          <cfa-icon className="state-summary__stage-icon">{stage.icon}</cfa-icon>
          <span>{stage.label}</span>
        </strong>
        <div className="state-summary__level">{capitalizeFirstLetter(level)}</div>
      </div>
      <div className="state-summary__dimension-graph">
        <LevelGraph variant="compact" level={level} showLabel={false} />
      </div>
    </div>
  );
};

export default StateSummary;
